
    import { defineComponent } from 'vue';
    import XBreadcrumb from '@/apps/shared/components/breadcrumb.vue';
    import CRMCotizadorWebService from '@/apps/shared/services/crm-service';
    import phoneValidateService from '@/apps/shared/services/phone-service';
    import localityService from '@/apps/shared/services/locality-service';
    import getVWHealthGridGroups from '@/apps/shared/services/getVWGridGroups-service';
    import getVWHealthGridCovers from '@/apps/shared/services/getVWGridCovers-service';
    import getHealthQuotation from '@/apps/shared/services/healthQuotation-service';
    import getSafeHealthMaxRequotation from '@/apps/shared/services/getSafeHealthMaxRequotation-service';
    import getCoverCapitalAndDescription from '@/apps/shared/services/getCoverCapitalAndDescription-service';
    import discountRangeService from '@/apps/shared/services/getDiscountRange-service';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';
    import TitleAndPromotions from '@/apps/shared/components/TitlesAndPromotions.vue';
    import ContactInfo from "@/apps/shared/components/ContactInfo.vue";
    import { TitleAndPromotionsDetails } from '@/apps/shared/models/titleAndPromotionsDetails';

    export default defineComponent({
        name: 'healthMaxHome-view',
        productId: 321,
        components: {
            XBreadcrumb,
            TitleAndPromotions,
            ContactInfo
        },
        data() {
            return {
                titleAndPromotionDetails: {
                    title: "Salud",
                    subTitle: "Para comenzar, vamos a pedirte algunos datos personales",
                    product: "Salud",
                    icon: {
                        src: '/Logos/salud.svg',
                        alt: 'Salud Segura Max',
                        title: 'Salud Segura Max'
                    },
                    iconPromotion: {
                        src: '/Logos/salud.svg',
                        alt: 'salud-promo',
                        title: 'salud-promo'
                    }
                } as TitleAndPromotionsDetails,

                localityList:
                    function (params) {
                        return localityService.getLocalityList(params)
                    },
                title: "Salud Segura Max",
                validatePhone: false,
                cityId: null,
                zipCode: null,
                telephone: '',
                areaCode: '',
                email: null,
                selectedLocality: null,
                cityName: null,
                messageErrorPhone: null,
                messageErrorAreaCode: null,
                messageErrorDigits: null,
                validDigits: null,
                relationId: null,
                quotationId: null,
                peopleToCover: 1,
                peopleToCoverMin: 1,
                peopleToCoverMax: 8,
                minimumInputLength: 4,
                containDiscountRange: false,
                changeTitlePromotions: false,
                discountRate: null,
                autocompleteConfig: {
                    formatResult: NF.Autocomplete.Result.TAGS,
                    selection: NF.Autocomplete.Result.TAGS,
                    minimumInputLength: 4
                },
                breadcrumItems: [
                    { text: 'Inicio', path: '/salud-segura-max' },
                ],
                leadId: null,
                referente: null,
                responseHealth321Quotation: null,
            }
        },
        created() {
            window.globalThis.validateLocality = function () {
                return Boolean(this.selectedLocality);
            }.bind(this);
        },
        methods: {
            async pageCustomization() {
                const defaultTitle = 'Salud Segura Max';
                const actualPath = '/salud-segura-max';
                const actualStep = 'tab-one';
                // Llamamos al helper que se encarga de toda la lógica
                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, actualStep, null);
                }
                catch (error) {
                    const statusCode = error.response.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },

            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultSafeHealthMaxGTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },
            restPeopleToCover() {
                this.peopleToCover -= 1;
            },
            addPeopleToCover() {
                this.peopleToCover += 1;
            },

            comenzar() {
                NF.UI.Page.block();
                const contactInfoData = this.$refs.contactInfoRef.getFormData();
                const { email, telephone, areaCode, validTelephone, validEmail } = contactInfoData;
                this.email = email;
                this.telephone = telephone;
                this.areaCode = areaCode;
                this.validatePhone = validTelephone;
                const validateEmail = validEmail;
                if (this.validatePhone && validateEmail && this.selectedLocality != null) {
                    let userName = '';
                    let userToken = '';
                    let tokenType = "";
                    let correlationInformation = "";
                    let onDate = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1).toISOString();
                    let groupId = this.peopleToCover === 1 ? 1 : 3;
                    // Llamada para obtener grupos de cobertura de salud
                    getVWHealthGridGroups.getVWHealthGridGroups(321, onDate, correlationInformation, userName, userToken, tokenType)
                        .then(responseGetVWHealthGridGroups => {
                            sessionStorage.setItem("responseGetVWHealthGridGroups", JSON.stringify(responseGetVWHealthGridGroups));

                            let coverCodeArray = [1, 2, 3, 4];
                            let coverCode = JSON.stringify(coverCodeArray);

                            // Promesa para obtener información de cobertura para cada grupo
                            const promises = responseGetVWHealthGridGroups.filter(item => item.id == groupId).map(item => {
                                const coverPercent = item.coverPercent;
                                const id = item.id;
                                return getCoverCapitalAndDescription.getHealthCoverCapitalAndDescription(321, coverPercent, 0, onDate, coverCode, 1, correlationInformation, userName, userToken, tokenType)
                                    .then(responseGetHealthCoverCapitalAndDescription => {
                                        sessionStorage.setItem("getHealthCoverCapitalAndDescription-Group" + id, JSON.stringify(responseGetHealthCoverCapitalAndDescription));
                                    })
                                    .catch(error => {
                                        console.error("Error al llamar al servicio getCoverCapitalAndDescription:", error);
                                        throw error; // Propagar el error para que se maneje en el siguiente bloque catch
                                    });
                            });

                            // Promesa para obtener coberturas de salud adicionales
                            const additionalCoveragePromise = getVWHealthGridCovers.getVWHealthGridCovers(321, onDate, 1, null, correlationInformation, userName, userToken, tokenType)
                                .then(responseGetVWHealthGridCovers => {
                                    sessionStorage.setItem("responseGetVWHealthGridCovers", JSON.stringify(responseGetVWHealthGridCovers));

                                    // Extraer listado de beneficios adicionales
                                    //grupo individual o familiar
                                    let additionalBenefits = responseGetVWHealthGridCovers.vwGridCovers.filter(cover =>
                                        cover.gridCategoriesId === 2
                                    ).map(item => {
                                        return {
                                            coverDescription: item.coverDescription.trim(),
                                            isChecked: item.verticalGroupsId.includes(groupId),
                                            coverDescriptionTooltip: item.coverDescriptionTooltip?.trim() ?? "",
                                        };
                                    });
                                    sessionStorage.setItem("additionalBenefitsVWHealthGridCovers", JSON.stringify(additionalBenefits));
                                });

                            // Esperar a que todas las promesas se resuelvan antes de continuar
                            return Promise.all([...promises, additionalCoveragePromise]);
                        })
                        .then(() => {
                            let body = JSON.stringify({
                                userName: userName,
                                userToken: userToken,
                                tokenType: tokenType,
                                correlationInformation: correlationInformation,
                                cityId: parseInt(this.cityId),
                                zipCode: this.zipCode,
                                peopleToCover: this.peopleToCover
                            });

                            // Llamada para crear la cotización de salud
                            return getHealthQuotation.createHealth321Quotation(body);
                        })
                        .then(responseHealth321Quotation => {
                            sessionStorage.setItem("responseHealth321Quotation", JSON.stringify(responseHealth321Quotation));
                            this.quotationId = responseHealth321Quotation.plans[0].quotationId;
                            this.responseHealth321Quotation = responseHealth321Quotation;
                            if (this.peopleToCover > 1) {
                                // Llamada para recotización
                                return getSafeHealthMaxRequotation.getSafeHealthMaxRequotation(this.peopleToCover, this.quotationId);
                            }
                        })
                        .then(requotationResult => {
                            if (requotationResult) {
                                sessionStorage.setItem("responseHealth321Requotation", JSON.stringify(requotationResult));
                            }
                        })
                        .then(() => {
                            // Almacenar datos en sessionStorage y redirigir a otra página
                            let dataTomador = {
                                areaCode: this.areaCode,
                                telephone: this.telephone,
                                email: this.email,
                                cityId: this.cityId,
                                cityName: this.cityName,
                                zipCode: this.zipCode,
                                selectedLocality: this.selectedLocality,
                                peopleToCover: this.peopleToCover,
                            };
                            sessionStorage.setItem("DataTabHome", JSON.stringify(dataTomador));
                            new Promise<any>(async (resolve) => {
                                // Llamada para crear o editar un lead
                                if (this.responseHealth321Quotation != null) {
                                    CRMCotizadorWebService.CreateOrEditLead(this.leadId, this.email, location.href, null, null, 321, false, "1", null, null, null).then((response) => {
                                        sessionStorage.setItem("LeadId", JSON.stringify(response));
                                        this.$router.push({
                                            name: 'healthMaxPlansSelection-view',
                                        });

                                        NF.UI.Page.unblock();
                                        resolve(true);
                                    });
                                }
                            });
                        })
                        .catch(error => {
                            NF.UI.Page.unblock();
                            let statusCode = null;
                            // Si es un error de Axios (por ejemplo, 4xx, 5xx)
                            if (error.response && error.response.status) {
                                statusCode = error.response.status;
                            } else if (error.message === '204') {
                                // Error lanzado manualmente en el service para 204
                                statusCode = 204;
                            }
                            NF.UI.Page.unblock();
                            console.error("Error en la ejecución:", error);
                            // Manejar cualquier error que ocurra
                            window.globalThis.dataLayer.push({
                                'pas': null,
                                'email': this.email,
                                'product': 'salud',
                                'event': 'errorUsuario',
                                'paso': 'cotizador-salud-datos-personales',
                                'referente': this.referente
                            });
                            this.Bus.$emit('show-service-fail', statusCode, [() => this.comenzar()]);
                        });
                } else {
                    NF.UI.Page.unblock();
                }
                sessionStorage.setItem("peopleToCover", this.peopleToCover);
            }

            ,
            async getSafeHealthMaxDiscountRange() {
                NF.UI.Page.block();
                await discountRangeService.getSafeHealthMaxDiscountRange().then((response) => {
                    this.containDiscountRange = response.length > 0;
                    if (this.containDiscountRange) {
                        this.responseDiscountRange = response;
                        sessionStorage.setItem("thereIsDiscount", "true");
                        this.discountRate = parseInt(this.responseDiscountRange[0].discountMaxValue, 10);
                        this.fechaPromotions = new Date();
                        var FechaInicioEvento = new Date(Date.parse("05/15/2025"));
                        var FechaFinEvento = new Date(Date.parse("05/18/2025"));
                        this.changeTitlePromotions = (this.fechaPromotions >= FechaInicioEvento && this.fechaPromotions <= FechaFinEvento);
                        this.sendDataDiscount = {
                            discountRate: this.discountRate,
                            containDiscountRange: this.containDiscountRange,
                            changeTitlePromotions: this.changeTitlePromotions,
                        };
                        this.$refs.titlesAndPromotions.setDiscountData(this.sendDataDiscount);
                    } else {
                        sessionStorage.setItem("thereIsDiscount", "false");
                        this.containDiscountRange = false;
                    }
                }).finally(() => {
                    NF.UI.Page.unblock();
                });
            },
            async getInitData() {
                this.leadId = JSON.parse(sessionStorage.getItem("LeadId"));
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                var validBack = sessionStorage.getItem("pressBack");
                if (validBack) {
                    sessionStorage.removeItem("pressBack");
                    var dataTomador = sessionStorage.getItem("DataTabHome");
                    if (dataTomador != null) {
                        this.dataTomadorJson = JSON.parse(dataTomador!);
                        this.$refs.contactInfoRef.setFormData(this.dataTomadorJson);
                        this.cityId = this.dataTomadorJson.cityId;
                        this.cityName = this.dataTomadorJson.cityName;
                        this.zipCode = this.dataTomadorJson.zipCode;
                        this.selectedLocality = this.dataTomadorJson.selectedLocality;
                        this.peopleToCover = this.dataTomadorJson.peopleToCover;
                    }
                }
                else {
                    window.globalThis.dataLayer.push({
                        'pas': null,
                        'email': this.email,
                        'product': 'salud',
                        'event': 'cotizador-salud-view',
                        'referente': this.referente
                    });
                    sessionStorage.clear();
                    sessionStorage.setItem("Referente", this.referente);
                    sessionStorage.setItem("ExitOrContinueModal", "true");
                }
            }
        },
        watch: {
            peopleToCover(newVal) {
                if (newVal > this.peopleToCoverMax) {
                    this.peopleToCover = this.peopleToCoverMax;
                } else if (newVal < this.peopleToCoverMin) {
                    this.peopleToCover = this.peopleToCoverMin;
                }
            },
            selectedLocality(newVal) {
                if (this.selectedLocality != null) {
                    this.localityIsSelected = true;
                    this.cityId = newVal.id;
                    this.zipCode = newVal.zipCode;
                }
            },
        },
        async mounted() {
            try {
                NF.UI.Page.block();

                var referente = sessionStorage.getItem("Referente");
                referente == 'null' || referente == null ? this.referente = null : this.referente = referente; 

                await this.pageCustomization();
                const parallelPromises = [
                    this.updateByProductGoogleAnalytics(),
                    this.getSafeHealthMaxDiscountRange()
                ];

                await Promise.all([
                    ...parallelPromises,
                ]);

                this.getInitData();
            } finally {
                NF.UI.Page.unblock();
            }
        },
    })
